import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

export const Container = styled.div`
  position: relative;
  background: ${getThemeColor('primary', theme.tints.primary)};
  border-radius: 22px;
  color: #fff;
  font-size: 14px;

  html[lang=ta] & {
    font-size: 11px;
  }

  @media all and (orientation: portrait) {
    [lang=ru] [data-e2e=last-round-stats] & {
      font-size: 11px;
    }
  }
`;

export const Menu = styled.nav`
  background: ${getThemeColor('background')};
  border-radius: 8px;
  position: absolute;
  top: -5px;
  right: ${({ isHandheld }) => (isHandheld ? '33px' : '15px')};
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transform: translateY(0);
  width: auto;
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  font-size: 14px;

  ul {
    display: flex;
    flex-flow: column nowrap;
    list-style: none;
    padding: 5px 0px 5px 0px;
    margin: 0px;
    li {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    a {
      text-decoration: none;
      padding: 15px 20px;
      display: block;
    }
  }
`;

export const Item = styled.li`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-flow: row nowrap;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  min-width: 145px;

  padding: 0 1em;
  border-radius: 7px;

  color: ${({ isSelected }) => (isSelected ? '#ffb300' : 'currentColor')};

  @media (max-width:961px)  {
    padding: unset;
  }

  & > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (hover: hover) {
    &:hover {
      & > *:first-child {
        color: #1db1f9;
        fill: currentColor;
        stroke: currentColor;
      }
    }
  }
`;

export const upClassName = css`
  transform: rotate(90deg);
`;

export const downClassName = css`
  transform: rotate(-90deg);
`;

export const activeClassName = css`
  opacity: 1;
  visibility: visible;
  z-index: 10;
`;
